module.exports = __webpack_public_path__ + "img/photo_230150655_2.4c441d2a.jpg";